import React from 'react'
import { Input } from '@progress/kendo-react-inputs';
import services from "../../../services";
import $ from "jquery";
import Inserirvasilha from './Inserirvasilha';
var mediArr = []
var editVasilhaDimension = []
var thisState;
class TipoOptionForm extends React.Component{

    state = {
        data : {},
        row:{},
        medida1:'',
        medida2:'',
        medida3:'',
        medida4:'',
        medida5:'',
    }



    componentDidMount(){

        editVasilhaDimension = [];
        mediArr = [];
        
        //$('#tipoVasilhas option').removeAttr("selected","selected");
        thisState = this;
        (async () => {    
            // var idVas = parseInt($("#tipoVasilhas :selected").val())
            // let tipoCurrentArr = this.props.tipoOptionList.filter((object) => {
            //     console.log(tipoCurrentArr , object , "ENCONTAR VASILHA")
            //     if (idVas == object.codTipoVasilha) {
            //         return true;
            //     } else return false;
            // });
            // console.log("yes this is the one......", tipoCurrentArr);
            // var idVas = $("#tipoVasilhas :selected").val()
            // var TipoVas = $("#tipoVasilhas :selected").text()

            if(parseInt($("#tipoVasilhas :selected").val()) != 0 && $("#tipoVasilhas :selected").val() != ""){
                
                var dataVasilha = {"idTipoVasilha" :parseInt($("#tipoVasilhas :selected").val()), "idVasilha": (this.props.row.idVasilha != null) ? this.props.row.idVasilha : this.props.data.idVasilha }
                console.log(this.props)
               
                if(dataVasilha.idVasilha == undefined ){
                    dataVasilha.idVasilha = 0
                }
                
                
                var vasilha = await services.apiCall.requestApi(
                    "/InstalacaoVinica/GetDimensoesVasilha",
                    dataVasilha,
                    "get"
                ); 
               if(vasilha){
                  $('#capac').val("");
                console.log("Detalhes idddddddd", vasilha)
                
                mediArr.push(vasilha.medida1, vasilha.medida2,vasilha.medida3,vasilha.medida4,vasilha.medida5)
    
                editVasilhaDimension.push(vasilha.dimensao1,vasilha.dimensao2,vasilha.dimensao3,vasilha.dimensao4,vasilha.dimensao5)
     
                this.setState({
                    row:this.props.row,
                    data:mediArr,
                    medida1:vasilha.medida1,
                    medida2:vasilha.medida2,
                    medida3:vasilha.medida3,
                    medida4:vasilha.medida4,
                    medida5:vasilha.medida5
                })
               }
                
    
                this.vasilhaMeasurements(parseInt($("#tipoVasilhas :selected").val()))

                $("#tipoVasilhas option[value='" + parseInt($("#tipoVasilhas :selected").val()) + "']").attr("selected","selected");
            }else if(this.props.data.idVasilha != undefined){
                var dataVasilha = { "idVasilha": this.props.data.idVasilha}
                var vasilha = await services.apiCall.requestApi(
                    "/InstalacaoVinica/GetDimensoesVasilha",
                    dataVasilha,
                    "get"
                ); 
                    if(vasilha){
                        $('#capac').val("");
                        console.log("Detalhes idddddddd", vasilha)
                
                        mediArr.push(vasilha.medida1, vasilha.medida2,vasilha.medida3,vasilha.medida4,vasilha.medida5)
            
                        editVasilhaDimension.push(vasilha.dimensao1,vasilha.dimensao2,vasilha.dimensao3,vasilha.dimensao4,vasilha.dimensao5)
             
                        this.setState({
                            row:this.props.row,
                            data:mediArr,
                            medida1:vasilha.medida1,
                            medida2:vasilha.medida2,
                            medida3:vasilha.medida3,
                            medida4:vasilha.medida4,
                            medida5:vasilha.medida5
                        })
                        
                        this.vasilhaMeasurements(parseInt($("#tipoVasilhas :selected").val()))
                        Inserirvasilha.getVasilhasCalculation(editVasilhaDimension)
                        
                        $("#tipoVasilhas option[value='" + parseInt($("#tipoVasilhas :selected").val()) + "']").attr("selected","selected");
                    }
               
            }else{
                
            }
            console.log("ID TIPOOO", parseInt($("#tipoVasilhas :selected").val()))
            
            
            
              

        })();

        console.log("TipoOptionList",this.props.TipoOptionForm)

    }

    componentDidUpdate(prevProps) {
        if(JSON.stringify(prevProps.data) !== JSON.stringify(this.props.data)) {
            this.vasilhaMeasurements(parseInt($("#tipoVasilhas :selected").val()))
        }
        thisState = this;
    }

    vasilhaMeasurements = (TipoVasilha) => {
        let medidaArr = {}
        //let TipoVasilha = this.props.data.idVasilha

        // mediArr.map((key, index) => {
        //     medidaArr[key] = this.props.data[editVasilhaDimension[index]] || ""
        // })
        Object.keys(mediArr).map((medida) => {

            if(mediArr[medida] != "-"){
                // medidaArr[medida] = editVasilhaDimension[medida] || ""
                editVasilhaDimension.map((dimensao) => {
                    if(dimensao != "-")
                        medidaArr[medida] = editVasilhaDimension[dimensao] || ""
                })
            }
        })
        this.setState({
            data: {...this.state.data, ...medidaArr}
        },()=>{
            console.log("our dataaaaaaa", TipoVasilha)
            this.props.calFormValue(this.state.data, TipoVasilha)
        })
    }

    handleChange = (e) => {
        let data = {...this.state.data}
        // if (e.target.props.id != undefined){
        //     data[e.target.props.id] = e.target.value
        // }

      
        var medida1 = $("#0").val() != undefined ? $("#0").val() : "-"
        var medida2 = $("#1").val() != undefined ? $("#1").val() : "-"
        var medida3 = $("#2").val() != undefined ? $("#2").val() : "-"
        var medida4 = $("#3").val() != undefined ? $("#3").val() : "-"
        var medida5 = $("#4").val() != undefined ? $("#4").val() : "-"
        var dataarray = []
        dataarray.push(medida1 ,medida2,  medida3 , medida4 , medida5)
        data = dataarray
        editVasilhaDimension = [];

        $.each(data, function(i, item) {
            editVasilhaDimension.push(data[i]);
        });

        // editVasilhaDimension = arrayData;
        let TipoVasilha = parseInt($("#tipoVasilhas :selected").val())
        this.setState({
            data : data
       // }
        // ,()=>{
        //     this.props.calFormValue(data,TipoVasilha)
        })
    }
    
    checkFormatOfInput = (e) => {
        let checkIfNum = false
        if (e.key !== undefined) {
            checkIfNum = e.key === "e" || e.key === "+" || e.key === "-" || e.key === "E";
          }
          else if (e.keyCode !== undefined) {
            checkIfNum = e.keyCode === 69 || e.keyCode === 187 || e.keyCode === 189;
          }
          return checkIfNum && e.preventDefault();
    }

    static GetDimencoesCampos(){
        editVasilhaDimension = [];
        mediArr = [];
        
        if(thisState){
            (async () => {    
           
                if(parseInt($("#tipoVasilhas :selected").val()) != 0 && $("#tipoVasilhas :selected").val() != ""){
                    
                    var dataVasilha = {"idTipoVasilha" :parseInt($("#tipoVasilhas :selected").val()), "idVasilha": (thisState.props.row.idVasilha != null) ? thisState.props.row.idVasilha : thisState.props.data.idVasilha }
                   
                    if(dataVasilha.idVasilha == undefined ){
                        dataVasilha.idVasilha = 0
                    }
                    
                    
                    var vasilha = await services.apiCall.requestApi(
                        "/InstalacaoVinica/GetDimensoesVasilha",
                        dataVasilha,
                        "get"
                    ); 
                   if(vasilha){
                      $('#capac').val("");
                    console.log("Detalhes idddddddd", vasilha)
                    
                    mediArr.push(vasilha.medida1, vasilha.medida2,vasilha.medida3,vasilha.medida4,vasilha.medida5)
        
                    editVasilhaDimension.push(vasilha.dimensao1,vasilha.dimensao2,vasilha.dimensao3,vasilha.dimensao4,vasilha.dimensao5)
         
                    thisState.setState({
                        row:thisState.props.row,
                        data:mediArr,
                        medida1:vasilha.medida1,
                        medida2:vasilha.medida2,
                        medida3:vasilha.medida3,
                        medida4:vasilha.medida4,
                        medida5:vasilha.medida5
                    })
                   }
                    
        
                   thisState.vasilhaMeasurements(parseInt($("#tipoVasilhas :selected").val()))
    
                    $("#tipoVasilhas option[value='" + parseInt($("#tipoVasilhas :selected").val()) + "']").attr("selected","selected");
                }else if(thisState.props.data.idVasilha != undefined){
                    var dataVasilha = { "idVasilha": thisState.props.data.idVasilha}
                    var vasilha = await services.apiCall.requestApi(
                        "/InstalacaoVinica/GetDimensoesVasilha",
                        dataVasilha,
                        "get"
                    ); 
                        if(vasilha){
                            $('#capac').val("");
                            console.log("Detalhes idddddddd", vasilha)
                    
                            mediArr.push(vasilha.medida1, vasilha.medida2,vasilha.medida3,vasilha.medida4,vasilha.medida5)
                
                            editVasilhaDimension.push(vasilha.dimensao1,vasilha.dimensao2,vasilha.dimensao3,vasilha.dimensao4,vasilha.dimensao5)
                 
                            thisState.setState({
                                row:thisState.props.row,
                                data:mediArr,
                                medida1:vasilha.medida1,
                                medida2:vasilha.medida2,
                                medida3:vasilha.medida3,
                                medida4:vasilha.medida4,
                                medida5:vasilha.medida5
                            })
                            
                            thisState.vasilhaMeasurements(parseInt($("#tipoVasilhas :selected").val()))
                            Inserirvasilha.getVasilhasCalculation(editVasilhaDimension)
                            
                            $("#tipoVasilhas option[value='" + parseInt($("#tipoVasilhas :selected").val()) + "']").attr("selected","selected");
                        }
                   
                }else{
                    
                }
                console.log("ID TIPOOO", parseInt($("#tipoVasilhas :selected").val()))
            })();
        }
        
    }

    render(){
        let { tipoOptionList } = this.props;

        var inputHtml = ""
        
        if(mediArr.length > 0){
           
            return (
                Object.keys(mediArr).map((medida) => {

                    if(mediArr[medida] != "-"){
                       
                       return <div className="col-md-6 remove-medidas-input"><div className="input-box active-grey"><Input id={medida} style={{ width: "100%" }} className="input-1" type="number" value={parseFloat(editVasilhaDimension[medida])}  name={mediArr[medida]} label={mediArr[medida]} onKeyDown={(e) => this.checkFormatOfInput(e)} onChange={(e) => this.handleChange(e)} /> </div></div>
                    }
                })
            )
            

        }else{
            inputHtml = "";
        }

        return (inputHtml)
        
    }

}

export default TipoOptionForm;